export default "asset/iconfont/5abc94b10c6fd7fe98024fa6b5e21fdb.woff";